import { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { toaster } from '../../helpers/toaster';
import { Search, TextInput, Loading, Row, Column } from 'carbon-components-react'
import Select from "../../helpers/FixRequiredSelect";
import React from "react";

import MyModal from '../../components/Modal/Modal';
import Label from '../../components/Label/Label';
import {
  selectStyles,
  formatReadOnlyField,
  formatReadOnlyStudyId,
} from '../../helpers/formUtils'
// constants
import { getRecruitStatusOptions } from '../../constants/connex'
import { getCountryOptions } from '../../constants/countries'
// api
import { getSimpleStudyList } from '../../api/studyListApi';
import {Location} from '@carbon/icons-react';
import { getAddressSuggestion, getPlaceDetail } from '../../api/misc.js';
import {uuid4} from '@sentry/utils';

const LocationDetailModal = ({
  mode,
  locationId = null,
  open = false,
  locationData = null,
  studyId = null,
  onClose = () => { },
  confirmSave,
  confirmUpdate,
  locationsLoading,
  setLocationsLoading,
  isStudyDetail,
  studyOrgStudyId,
  studyPgId
}) => {
  const formRef = useRef()
  const [modalMode, setModalMode] = useState("create");
  const [locationInfo, setLocationInfo] = useState(locationData);
  const [studyList, setStudyList] = useState([]);
  const [selectedStudy, setSelectedStudy] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(locationData?.recruitment_status || []);
  const [selectedStatusOverride, setSelectedStatusOverride] = useState([]);
  const [selectCountry, setSelectCountry] = useState(locationData?.country || []);
  const [selectCountryOverride, setSelectCountryOverride] = useState([]);

  const [fullAddress, setFullAddress] = useState(null);
  const [addressSuggestions, setAddressSuggestions] = useState([]);
  const [googSessionToken, setGoogSessionToken] = useState(null);
  const [selectedFullAddress, setSelectedFullAddress] = useState("");

  const [override, setOverride] = useState(locationData?.override || {});

  const [source, setSource] = useState(Boolean(locationData?.is_source_CTG) ? "ctg" : "user_created");
  const onlyAttachment = localStorage.getItem('only_attachment')
  useEffect(() => setModalMode(mode), [mode]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!googSessionToken) {
        setGoogSessionToken(uuid4())
      }
      // setSelectedFullAddress({label: fullAddress, value: fullAddress})
      if (fullAddress) {
        getAddressSuggestion(fullAddress, googSessionToken).then(res => {
          fillAddressSuggestions(res.data)
        })
      } else {
        setAddressSuggestions([])
      }
    }, 500)

    return () => {clearTimeout(timeout)}
  }, [fullAddress]);

  const fillAddressSuggestions = data => {
    const convert = i => {
      return {'label': i.description, 'value': i.place_id}
    }

    setAddressSuggestions(data.map(convert).concat({label: fullAddress, value: null}))
  }

  const onFullAddressSelect = (input) => {
    if (!input.value) {
      if (mode === 'create') {
        setLocationInfo({
          ...locationInfo, address: input.label
        })
        console.log(locationInfo)
      } else {
        let curOver = override || {};
        curOver = {
          ...curOver, address: input.label
        }
        if (source === "user_created") {
          changeLocationData({ ...locationInfo, ...curOver })
        } else {
          changeLocationData({ ...locationInfo, override: curOver })
        }
        setOverride(curOver)

      }
    }
    else {
      getPlaceDetail(input.value, googSessionToken).then(res => {
        const lat = res.data.geometry.location.lat.toFixed(7)
        const lng = res.data.geometry.location.lng.toFixed(7)
        const name = res.data.name
        const country = {label: res.data.country.long_name, value: res.data.country.long_name}

        input.label = `${name}, ${res.data.formatted_address}`
        setGoogSessionToken(null)
        if (mode === 'create') {
          changeLocationData({
            ...locationInfo, address: input.label, latitude: lat, longitude: lng, name: name,
            country: country.value
          })
          setSelectCountry(country)
        } else {
          let curOver = override || {};
          curOver = {
            ...curOver, address: input.label, latitude: lat, longitude: lng, name: name,
            country: country.value
          }

          if (source === "user_created") {
            changeLocationData({ ...locationInfo, ...curOver })
          } else {
            setSelectCountryOverride(country.value)
            changeLocationData({ ...locationInfo, override: curOver })
          }
          setOverride(curOver)
        }
      })
    }

    setSelectedFullAddress(input)
    setAddressSuggestions([])
  }

  useEffect(() => {
    setLocationInfo(locationData);
    setOverride(locationData?.override);
    setSelectedStatus(locationData?.recruitment_status || []);
    setSelectedFullAddress({label: locationData?.address, value: locationData?.address} || {})
    setSelectCountry(locationData?.country)

    const source = Boolean(locationData?.is_source_CTG) ? "ctg" : "user_created";
    setSource(source)

    if (source === 'user_created') {
      setSelectedStatusOverride(locationData?.recruitment_status)
      setSelectCountryOverride(locationData?.country)
    } else {
      setSelectCountryOverride(locationData?.override?.country)
      setSelectedStatusOverride(locationData?.override?.recruitment_status || "");
    }

    if (locationData && locationData.study) {
      for (var i = 0; i < studyList.length; i++) {
        let tempStudy = studyList[i];
        if (locationData.study == tempStudy.value)
          console.log('tempStudy', tempStudy)
          setSelectedStudy(tempStudy);
      }

    }
    console.log(locationData)
  }, [locationData]);

  const changeLocationData = (newData) => {
    setLocationInfo(newData);
  };

  const searchFullAddress = e => {
    changeLocationData({
      ...locationInfo,
      address: e.target.value,
    })
  }

  const saveLocation = (evt) => {
    evt.preventDefault()
    if (!selectedStudy) {
      return;
    }
    if (modalMode === "create") {
      let locInfo = locationInfo;
      if (studyId) {
        locInfo = {
          ...locInfo,
          study: studyId,
        };
      }

      confirmSave(locInfo).then((data) => {
        setSelectedStatus([])
        setSelectCountry([])
        if(isStudyDetail){
          setLocationInfo({
            study: studyPgId
          })
        }
        else{
          setLocationInfo({})
          setSelectedStudy([])
        }

        setAddressSuggestions([])
        setSelectedFullAddress(null)
      })
    } else {
      if (source === 'user_created') {
        locationInfo.override = {}
      }
      confirmUpdate(locationId, locationInfo)
    }
  };

  const onSelect = (item, fieldName, isOverride = false) => {
    if (fieldName === 'study') {
      setSelectedStudy(item)

    } else if (fieldName === 'recruitment_status') {
      if (source === 'user_created' && mode !== 'create') {
        setSelectedStatusOverride(item?.value)
        setSelectedStatus(item?.value)
      } else if (isOverride) {
        setSelectedStatusOverride(item?.value)
      } else {
        setSelectedStatus(item)
      }

    } else if (fieldName === 'country') {
      if (source === 'user_created' && mode !== 'create') {
        setSelectCountryOverride(item?.value)
        setSelectCountry(item?.value)
      }
      else if (isOverride) {
        setSelectCountryOverride(item?.value)
      } else {
        setSelectCountry(item)
      }
    }
    if (isOverride && source !== 'user_created') {
      const curOver = override || {}
      curOver[fieldName] = item?.value
      setOverride(curOver)
      changeLocationData({
        ...locationInfo,
        override: curOver,
      })
    } else {
      const curOver = override || {}
      curOver[fieldName] = item?.value
      changeLocationData({
        ...locationInfo,
        [fieldName]: item?.value,
      })
    }
  }

  // load study list
  useEffect(() => {
    getSimpleStudyList().then(res => {
      if (res && res.length) {
        let studies = res.map(item => ({
          value: item.id,
          label: item.org_study_id,
        }));
        setStudyList(studies);
      }
      setLocationsLoading(false);
    }).catch(error => {
      toaster("Failed to get simple study list", "error")
      // cogoToast.error("Failed to get simple study list", {
      //   heading: "Error",
      //   position: 'bottom-right'
      // });
      setLocationsLoading(false);
    });
  }, []);

  useEffect(() => {
    setSelectedStudy({label: studyOrgStudyId, value: studyPgId})
    setLocationInfo({
      ...locationInfo,
      study: studyPgId
    })}, [modalMode, studyPgId])

  const editHelperMult = (locAttrs, mode) => {
    const getTitle = (input) => {
      return input.split('_').map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`).join(' ')
    }

    const getValue = (attr) => {
      let value
      if (source === 'user_created') {
        value = locationInfo?.[attr] || ""
      } else {
        value = locationInfo?.override?.[attr] || ""
      }
      return value
    }

    return <Row>
      { onlyAttachment !== 'true' &&
        locAttrs.map((input) => {
          const strField = getTitle(input)
          return (
            <Column
              key={input}
              style={{ marginBottom: "18px" }}
            >
              <TextInput
                id={input}
                value={getValue(input)}
                labelText={strField}
                size="sm"
                onChange={e => {
                  const curOver = override || {};
                  curOver[input] = e.target.value
                  setOverride(curOver)
                  if (source === 'user_created') {
                    changeLocationData({
                      ...locationInfo,
                      [input]: e.target.value,
                      override: override
                    })
                  } else {
                    changeLocationData({
                      ...locationInfo,
                      override: override
                  })

                  }
                }}
              />
            </Column>
          )
        })
      }
      {
        (source !== 'user_created') &&
        locAttrs.map((input) => {
          const strField = getTitle(input)
          return (
            <Column key={input}>
              {formatReadOnlyField(
                `${strField}${mode === "create" ? "*" : ""}`,
                locationInfo?.[input] || "",
              )}
            </Column>
          )
        })
      }
    </Row>
  }

  const editHelper = (locAttr, mode, strField) => {
    let value
    if (source === 'user_created') {
      value = locationInfo?.[locAttr] || ""
    } else {
      value = locationInfo?.override?.[locAttr] || ""
    }

    return (
      <Row>
        { onlyAttachment !== 'true' && 
          <Column style={{ marginBottom: "18px" }}>
          <TextInput
            id={locAttr}
            value={value}
            labelText={strField}
            //placeholder={`Enter ${strField}`}
            size="sm"
            onChange={e => {
              const curOver = override || {};
              curOver[locAttr] = e.target.value
              setOverride(curOver)
              if (source === 'user_created') {
                changeLocationData({
                  ...locationInfo,
                  [locAttr]: e.target.value,
                  override: override
                })

              } else {
                changeLocationData({
                  ...locationInfo,
                  override: override
                })
              }
            }}
          />
        </Column>        
        }

        {(source !== 'user_created') &&
        <Column>
          {formatReadOnlyField(
            `${strField}${mode === "create" ? "*" : ""}`,
            locationInfo?.[locAttr] || "",
          )}
        </Column>}

      </Row>
    )
  }

  return (
    <MyModal
      modalHeading="Location Details"
      size={(mode === "create" || source === 'user_created') ? "sm" : "lg"}
      open={open}
      onRequestClose={onClose}
      passiveModal={false}
      primaryButtonDisabled={(onlyAttachment === "true" || (locationInfo?.latitude === "" || locationInfo?.longitude === "" || locationInfo?.country === ""))}
      primaryButtonText={(modalMode === "create") ? "Create Location" : "Update Location"}
      onRequestSubmit={() => formRef.current.requestSubmit()}
    >
      <LocationModalContent>
        {
          locationsLoading ?
            <Loading />
            :
            <></>
        }

        <form
          ref={formRef}
          onSubmit={saveLocation}
          className="bx--form" // carbon component styles
        >
          <PartWrapper>
            <InputWrapper>
              {(mode === "create" && !isStudyDetail) ?
                <>
                  <Label>Study ID*</Label>
                  <Select
                    options={studyList}
                    onChange={(item) => onSelect(item, 'study')}
                    classNamePrefix="xogene"
                    className="multi-select"
                    styles={selectStyles()}
                    required
                  />
                </>
                : (mode === "create" && isStudyDetail) ?
                <CtgDataStudyIdWrapper>
                  {formatReadOnlyStudyId(selectedStudy.label)}
                </CtgDataStudyIdWrapper>
                : <>
                  <CtgDataStudyIdWrapper>
                    {formatReadOnlyStudyId(selectedStudy.label)}
                  </CtgDataStudyIdWrapper>
                </>
              }
            </InputWrapper>
          </PartWrapper>
          {(mode !== "create" && source === 'ctg') &&
            <Row style={{ marginBottom: "18px" }}>
              { onlyAttachment !== 'true' &&
                <Column>
                  <Header>Override</Header>
                </Column>
              }
              
              <Column>
                <Header>CTG Data</Header>
              </Column>
            </Row>
          }
          {mode === "create" ?
            <PartWrapper>
              <Label>Recruitment Status</Label>
              <InputWrapper>
                <Select
                  options={getRecruitStatusOptions()}
                  onChange={(item) => onSelect(item, 'recruitment_status')}
                  value={selectedStatus}
                  classNamePrefix="xogene"
                  className="basic-single"
                  styles={selectStyles()}
                />
              </InputWrapper>
            </PartWrapper>
            :
            <Row>
              { onlyAttachment !== 'true' &&
                <Column>
                <PartWrapper>
                  <Label>Recruitment Status</Label>
                  <InputWrapper>
                    <Select
                      options={getRecruitStatusOptions()}
                      onChange={(item) => onSelect(item, 'recruitment_status', true)}
                      value={{ "value": selectedStatusOverride, "label": selectedStatusOverride }}
                      classNamePrefix="xogene"
                      className="basic-single"
                      styles={selectStyles()}
                    />
                  </InputWrapper>
                </PartWrapper>
              </Column>
              }
              

              {(source !== 'user_created') &&
              <Column>
                {formatReadOnlyField(
                  `Recruitment Status${mode === "create" ? "*" : ""}`,
                  locationInfo?.recruitment_status || "",
                )}
              </Column>}


            </Row>
          }
          {mode === "create" ?
            <div style={{ marginBottom: "18px" }}>
              <Label>Full Address</Label>
              <Select
                placeholder=""
                noOptionsMessage={() => "Search the address..."}
                components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null }}
                options={addressSuggestions}
                isClearable={false}
                isSearchable
                onInputChange={input => {
                  setFullAddress(input)
                }}
                onChange={e => {
                  onFullAddressSelect(e)
                }}

                // onBlur={e => {
                //   console.log(e)
                // }}
                classNamePrefix="xogene"
                className="basic-single"
                styles={selectStyles()}
                id="full_address"
                value={ selectedFullAddress || ""}
              />
            </div>
            :
            <Row>
              { onlyAttachment !== "true" && 
                <Column style={{ marginBottom: "18px" }}>
                  <div style={{ marginBottom: "18px" }}>
                    <Label>Full Address</Label>
                    <Select
                      placeholder=""
                      noOptionsMessage={() => "Search the address..."}
                      components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null }}
                      options={addressSuggestions}
                      onInputChange={input => {
                        setFullAddress(input)
                      }}
                      onChange={e => {
                        onFullAddressSelect(e)
                      }}
                      classNamePrefix="xogene"
                      className="basic-single"
                      styles={selectStyles()}
                      id="full_address"
                      value={selectedFullAddress}
                    />
  
                  </div>
                </Column>
              }

              {(source !== 'user_created') &&
              <Column>
                {formatReadOnlyField(
                  `"Full Address"${mode === "create" ? "*" : ""}`,
                  locationInfo?.["address"] || "",
                )}
              </Column>}

            </Row>
          }
          {mode === "create" ?
            <div style={{ marginBottom: "18px" }}>
              <TextInput
                id="location_name"
                value={locationInfo?.name || ""}
                labelText="Location Name"
                onChange={e => changeLocationData({
                  ...locationInfo,
                  name: e.target.value,
                })}
              />
            </div>
            : editHelper("name", mode, "Location Name")
          }
          {mode === "create" ?
            <Row>
              { onlyAttachment !== "true" && 
              <Column style={{ marginBottom: "18px" }}>
                <TextInput
                  id="latitude"
                  value={locationInfo?.latitude || ""}
                  labelText="Latitude*"
                  invalid={locationInfo?.latitude === ""}
                  onChange={e => changeLocationData({
                    ...locationInfo,
                    latitude: e.target.value,
                  })}
                />
              </Column>
              }

              <Column style={{ marginBottom: "18px" }}>
                <TextInput
                  id="longitude"
                  value={locationInfo?.longitude || ""}
                  labelText="Longitude*"
                  invalid={locationInfo?.longitude === ""}
                  onChange={e => changeLocationData({
                    ...locationInfo,
                    longitude: e.target.value,
                  })}
                />
              </Column>
            </Row>
            : editHelperMult(["latitude", "longitude"], mode)
          }

          {mode === "create" ?
            <PartWrapper>
              <Label>Country*</Label>
              <InputWrapper>
                <Select
                  options={getCountryOptions()}
                  onChange={(item) => onSelect(item, 'country')}
                  value={selectCountry}
                  classNamePrefix="xogene"
                  className="basic-single"
                  styles={selectStyles()}
                  isSearchable
                  required
                />
              </InputWrapper>
            </PartWrapper>
            :
            <Row>
              { onlyAttachment !== "true" &&
              <Column>
              <PartWrapper>
                <Label>Country</Label>
                <InputWrapper>
                  <Select
                    options={getCountryOptions()}
                    onChange={(item) => onSelect(item, 'country', true)}
                    value={{ "value": selectCountryOverride, "label": selectCountryOverride }}
                    classNamePrefix="xogene"
                    className="basic-single"
                    styles={selectStyles()}
                    isSearchable
                    required
                  />
                </InputWrapper>
              </PartWrapper>
            </Column>              
              }


              {(source !== 'user_created') &&
              <Column>
                {formatReadOnlyField(
                  `Country${mode === "create" ? "*" : ""}`,
                  locationInfo?.country || "",
                )}
              </Column>}
            </Row>
          }

          {mode === "create"  ?
            <div style={{ marginBottom: "18px" }}>
              <TextInput
                id="contact_email"
                value={locationInfo?.contact_email || ""}
                labelText="Contact Email"
                onChange={e => changeLocationData({
                  ...locationInfo,
                  contact_email: e.target.value,
                })} />
            </div>
            : editHelper('contact_email', mode, 'Contact Email')
          }
          {mode === "create" ?
            <div style={{ marginBottom: "18px" }}>
              <TextInput
                id="contact_name"
                value={locationInfo?.contact_name || ""}
                labelText="Contact Name"
                onChange={e => changeLocationData({
                  ...locationInfo,
                  contact_name: e.target.value,
                })} />
            </div>
            : editHelper('contact_name', mode, 'Contact Name')
          }
          {mode === "create" ?
            <Row>
              <Column style={{ marginBottom: "18px" }}>
                <TextInput
                  id="contact_phone"
                  value={locationInfo?.contact_phone || ""}
                  labelText="Contact Phone"
                  onChange={e => changeLocationData({
                    ...locationInfo,
                    contact_phone: e.target.value,
                  })} />
              </Column>
              <Column style={{ marginBottom: "18px" }}>
                <TextInput
                  id="contact_phone_ext"
                  value={locationInfo?.contact_phone_ext || ""}
                  labelText="Contact Phone Extension"
                  onChange={e => changeLocationData({
                    ...locationInfo,
                    contact_phone_ext: e.target.value,
                  })} />
              </Column>
            </Row>
            : editHelperMult(["contact_phone", "contact_phone_ext"], mode)
          }
        </form>
      </LocationModalContent>
    </MyModal>
  );
};

export default LocationDetailModal;

const LocationModalContent = styled.div`
  display: flex;
  flex-direction: column;
`

const PartWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 18px;
`

const InputWrapper = styled.div`
  width: 100%;
`
const Header = styled.div`
  font-color: #666666;
  font-size: 1.6em;
`

const CtgDataStudyIdWrapper = styled.div`
  width: 48%;
`
